if (!customElements.get('upsell-tabs')) {
  class UpsellTabs extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
    }

    handleClick(event) {
      const trigger = event.target.closest('[data-target]');
      if(!trigger) return;
      const target = document.querySelector(trigger.getAttribute('data-target'));
      if(!target) return;

      this.querySelectorAll('.is-active').forEach(element => element.classList.remove('is-active'));

      trigger.classList.add('is-active');
      target.classList.add('is-active');
    }

    disconnectedCallbacks() {
      this.removeEventListener('click', this.handleClickRef);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClickRef);
    }
  }

  customElements.define('upsell-tabs', UpsellTabs);
}
